export function meaningfulAiString(val) {
    if (val == null || typeof val !== 'string') return false;
    const t = val.trim();
    if (t === '') return false;
    const lower = t.toLowerCase();
    if (lower === 'null' || lower === 'undefined') return false;
    return true;
}

function mergeStringIndexArrays(incoming, previous) {
    if (!Array.isArray(previous) || previous.length === 0) {
        return Array.isArray(incoming) ? incoming : previous;
    }
    if (!Array.isArray(incoming)) {
        return previous;
    }
    const maxLen = Math.max(incoming.length, previous.length);
    const out = [];
    for (let i = 0; i < maxLen; i++) {
        const inc = i < incoming.length ? incoming[i] : undefined;
        const prev = i < previous.length ? previous[i] : undefined;
        if (meaningfulAiString(inc)) {
            out.push(inc);
        } else if (meaningfulAiString(prev)) {
            out.push(prev);
        } else if (inc !== undefined) {
            out.push(inc);
        } else if (prev !== undefined) {
            out.push(prev);
        }
    }
    return out;
}

function mergeAiGradeArrays(incoming, previous) {
    if (!Array.isArray(previous) || previous.length === 0) {
        return Array.isArray(incoming) ? incoming : previous;
    }
    if (!Array.isArray(incoming)) {
        return previous;
    }
    const maxLen = Math.max(incoming.length, previous.length);
    return Array.from({ length: maxLen }, (_, i) => {
        const inc = incoming[i];
        const prev = previous[i];
        const incEmpty =
            inc == null || (typeof inc === 'object' && inc !== null && Object.keys(inc).length === 0);
        const prevObj = prev && typeof prev === 'object';
        if (!incEmpty) return inc;
        if (prevObj) return prev;
        return inc !== undefined ? inc : prev;
    });
}

export function mergeSubmissionUpdate(existing, incoming) {
    if (!incoming) return existing;
    const merged = { ...existing, ...incoming };
    if (incoming.ai_suggestion !== undefined) {
        if (incoming.ai_suggestion === null) {
            merged.ai_suggestion = existing.ai_suggestion;
        } else {
            merged.ai_suggestion = mergeStringIndexArrays(
                Array.isArray(incoming.ai_suggestion) ? incoming.ai_suggestion : [],
                Array.isArray(existing.ai_suggestion) ? existing.ai_suggestion : []
            );
        }
    }
    if (incoming.ai_feedback !== undefined) {
        if (incoming.ai_feedback === null) {
            merged.ai_feedback = existing.ai_feedback;
        } else {
            merged.ai_feedback = mergeStringIndexArrays(
                Array.isArray(incoming.ai_feedback) ? incoming.ai_feedback : [],
                Array.isArray(existing.ai_feedback) ? existing.ai_feedback : []
            );
        }
    }
    if (incoming.ai_grade !== undefined) {
        if (incoming.ai_grade === null) {
            merged.ai_grade = existing.ai_grade;
        } else {
            merged.ai_grade = mergeAiGradeArrays(
                Array.isArray(incoming.ai_grade) ? incoming.ai_grade : [],
                Array.isArray(existing.ai_grade) ? existing.ai_grade : []
            );
        }
    }
    return merged;
}

export function mergeSubmissionsListPayload(existingState, incomingPayload) {
    if (!Array.isArray(incomingPayload)) return existingState;
    return incomingPayload.map(incoming => {
        const prev = existingState.find(x => x && x.id === incoming.id);
        return prev ? mergeSubmissionUpdate(prev, incoming) : incoming;
    });
}
